module.exports = __webpack_public_path__ + "img/Fsc_Logo_Sidebar.73225271.svg";